module.exports = __webpack_public_path__ + "img/xmxxBg.83e4f9cf.png";